const prodEnvs = ['biz-tecma-prod'];
const isProd = () => {
  return prodEnvs.includes(process.env.REACT_APP_NAMESPACE);
};

export default isProd;
